import React from "react";
import { ClearingPartnerAccountPlanContainer } from "../../../containers";

const ClearingPartnerAccountPlan = (props) => {
  return <ClearingPartnerAccountPlanContainer {...props} />;
};

export default ClearingPartnerAccountPlan;
